export enum ResourceName {
    ALERTS = "alerts",
    CONTRACT_PROFILES = "contract-profiles",
    DEALER_CHANGE_LOGS = "dealer-change-logs",
    USER_LOGS = "user-logs",
    VALIDATION_REPORTS = "validation-reports",
    ALLOWED_PRODUCT_PROFILES = "allowed-products-profiles",
    CAMPAIGNS = "campaigns",
    CARD_IMPLEMENTATIONS = "card-implementations",
    CARD_DEFINITIONS = "card-definitions",
    CARD_ATTRIBUTES = "card-attributes",
    CARD_TYPES = "card-types",
    CONTRACTS = "contracts",
    CONTRACTS_VIRTUAL = "contracts-virtual",
    CONTRACTS_PHYSICAL = "contracts-physical",
    DATA_GROUPS = "data-groups",
    DCC_PROFILES = "dcc-profiles",
    DIALOG_PROFILES = "dialog-profiles",
    EMV_KERNEL_PROFILES = "emv-kernel-profiles",
    HOST_CONFIGURATIONS = "host-configurations",
    HOST_PRODUCT_CODES = "host-product-codes",
    HOST_OPERATORS = "host-operators",
    PAYMENT_METHOD_PROFILES = "payment-method-profiles",
    PAYMENT_METHODS = "payment-methods",
    POS_TYPES = "pos-types",
    POS_MAPPINGS = "pos-mappings",
    PRODUCT_PROFILES = "product-profiles",
    PRODUCTS = "products",
    PROMPT_DATA_PROFILES = "prompt-data-profiles",
    SITE_GROUPS = "site-groups",
    SITES = "sites",
    TERMINAL_IMPORT_LOG = "terminal-import-logs",
    TERMINAL_IMPORT_LOG_ITEM = "terminal-import-log-items",
    TERMINALS = "terminals",
    VAT_CODES = "vat-codes",
    DYNAMIC_PROPERTIES = "dynamic-properties",
    DYNAMIC_PROPERTY_GROUPS = "dynamic-property-groups",
    TERMINAL_PROFILES = "terminal-profiles",
    APPLICATION_PROFILE_LISTS = "applications-profiles",
    APPLICATION_PROFILE_CARD_DEFINITION = "card-profiles",
    APPLICATION_PROFILE_CARD_DEFINITION_APAC = "card-profiles-apac",
    APPLICATION_PROFILE_CARD_DEFINITION_EFT4F = "card-profiles-eft4f",
    APPLICATION_PROFILE_PROMPT_DATA = "prompt-data",
    ACQUIRER = "acquirers",
    ACQUIRER_PHYSICAL = "acquirers-physical",
    ACQUIRER_VIRTUAL = "acquirers-virtual",
    ACQUIRERS_TO_VIRTUAL = "physical-acquirers",
    TERMINAL_ID_GENERATOR = "generator/terminal-id",
    TERMINAL_COPY_ID_GENERATOR = "generator/terminal-copy-id",
    SITE_ID_GENERATOR = "generator/site-id",
    SITE_ID_COPY_GENERATOR = "generator/site-id-copy",
    CAP_KEYS = "cap-keys",
    AID_PREFERENCES = "aid-preferences",
    AID_PREFERENCES_CLESS = "aid-preferences-cless",
    EMV_CONFIGURATIONS = "emv-configurations",
    EMV_GLOBAL_CONFIGURATIONS = "emv-global-configurations",
    APP_CONFIGURATIONS = "app-configurations",
    APP_SCHEMA = "application-schemas",
    PERIODIC_CAMPAIGN = "periodic-campaigns",
    FORM_CONFIGURATION = "form-configurations",
    TERMINAL_PASSWORD = "terminal-password",
    HOST_RESPONSE_CODE = "host-response-codes",
    LOYALTY_ALLOWED_MATRIX = "loyalty-allowed-matrix",
    LOYALTY_MESSAGES = "loyalty-messages",
    PRINTING_PROFILES = "printing-profiles",
    GLOBAL_CONFIGURATIONS = "global-configurations",
    TERMINAL_VERSIONS = "terminal-versions",
    VIRTUAL_SITE_GROUPS = "virtual-site-groups",
    MANUAL_DAS_CONFIGURATION = "manual-das-configurations",
    COMPL_TRX_IMPORT = "compl-trx-import",
    CONFIGURATION_TRANSFER = "transfer-configuration",
    DASHBOARD = "dashboard",
    ORGANISATION_UNITS_TREE = "site-groups-tree",
    // NEXT RESOURCE
}

export enum ResourceVariant {
    APAC = "apac",
    EFT4F = "eft4f",
    VIRTUAL = "virtual",
    PHYSICAL = "physical",
    ORG_UNITS = "orgunits",
    TERMINALS = "terminals",
}
